import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import userPage from '../decorators/userPage';
import {
  getSubmitStatus,
  getSaveAddressStatus,
  getCreateAddressStatus,
  getIsAdmin,
  getIncludedInGroups,
  getIsResellerGroup,
  getLoggedInUser,
} from '../reducers';
import { findUser, saveUser, getUsersApiOptions } from '../actions/users';
import { createAddress, saveAddress } from '../actions/addresses';
import UserForm from '../components/UserForm';
import AddressForm from '../components/AddressForm';
import { filterUserAclChoices, managerUserAclGroups } from 'helpers/user';
import { can, permActions } from 'permissions';

class EditUser extends Component {
  state = {
    useDefault: false,
    defaultAddress: {},
    userTypes: [],
  };

  componentDidUpdate(oldProps) {
    if (this.props.user !== oldProps.user) {
      this.fetchUserTypes();
    }
  }

  fetchUserTypes = () => {
    const { isAdmin, isResellerGroup, isManager, user } = this.props;

    if (isAdmin || isResellerGroup) {
      getUsersApiOptions().then((res) => {
        if (res.error) {
          return;
        }

        const { choices } = res.acl_group_name;
        const filteredChoices = filterUserAclChoices(user, choices);

        this.setState({
          userTypes: filteredChoices.map(({ value }) => [value, value]),
        });
      });
    } else if (isManager) {
      this.setState({
        userTypes: managerUserAclGroups.map((value) => [value, value]),
      });
    }
  };

  useDefaultAddress = () => {
    const { user } = this.props;
    this.setState({
      useDefault: true,
      defaultAddress: {
        ...this.props.formValues,
        full_name: `${user.first_name} ${user.last_name}`,
        address1: '55 Broadway Ave',
        address2: '',
        city: 'New York',
        state: 'NY',
        country: 'USA',
        zip_code: '10006',
      },
    });
  };

  handleSaveAddress = (values) => {
    const { saveAddress, createAddress, findUser, user } = this.props;
    if (user.address[0]) {
      return saveAddress(values);
    } else {
      return createAddress({
        ...values,
        user_profile: user.id,
      }).then(() => {
        this.setState({ useDefault: false });
        return findUser(user.id);
      });
    }
  };

  getInitialValues = (showAclGroup, showEmail) => {
    const { user, isResellerGroup } = this.props;
    const initialValues = {
      id: user?.id,
      first_name: user?.first_name || '',
      last_name: user?.last_name || '',
      company_name: user?.company_name || '',
      phone_number: user?.phone_number || '',
      reference: user?.reference || '',
    };

    if (!isResellerGroup) {
      initialValues.reference = user?.reference || '';
    }

    if (showEmail) {
      initialValues.email = user?.email;
    }

    if (showAclGroup) {
      initialValues.acl_group_name = user.acl_group_name;
    }

    return initialValues;
  };

  render() {
    const {
      user,
      loggedInUser,
      saveUser,
      saveStatus,
      createAddressStatus,
      saveAddressStatus,
    } = this.props;
    const { useDefault, defaultAddress, userTypes } = this.state;
    const addressStatus = saveAddressStatus || createAddressStatus;
    if (!user) {
      return <div>Loading...</div>;
    }
    const showEmail = can(loggedInUser, permActions.EDIT_USER_EMAIL, {
      user,
    });
    const showAclGroup = can(loggedInUser, permActions.EDIT_USER_GROUP, {
      user,
    });
    const showEditAddress =
      Boolean(user.address?.length) &&
      can(loggedInUser, permActions.EDIT_ADDRESS, {
        loggedInUser,
        userId: user.id,
      });

    const addressInitialValues =
      user.address && user.address[0]
        ? user.address[0]
        : {
            full_name: `${user.first_name} ${user.last_name}`,
            phone: user.phone_number,
          };

    return (
      <div>
        <UserForm
          initialValues={this.getInitialValues(showAclGroup, showEmail)}
          user={user}
          userTypes={userTypes}
          onSubmit={(values) => saveUser(values, 'PATCH')}
          saveStatus={saveStatus}
          showAclGroup={showAclGroup}
          showEmail={showEmail}
        />

        {showEditAddress && (
          <div>
            <br />
            <h3>Edit address</h3>
            <button
              className="btn btn-default"
              onClick={this.useDefaultAddress}
            >
              Use Default Address
            </button>

            <br />

            {useDefault ? (
              <AddressForm
                onSubmit={this.handleSaveAddress}
                initialValues={defaultAddress}
                saveStatus={addressStatus}
              />
            ) : (
              <AddressForm
                onSubmit={this.handleSaveAddress}
                initialValues={addressInitialValues}
                saveStatus={addressStatus}
              />
            )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loggedInUser: getLoggedInUser(state),
  saveStatus: getSubmitStatus(state, 'user'),
  formValues: getFormValues('address')(state),
  saveAddressStatus: getSaveAddressStatus(state),
  createAddressStatus: getCreateAddressStatus(state),
  isResellerGroup: getIsResellerGroup(state),
  isAdmin: getIsAdmin(state),
  isManager: getIncludedInGroups(state, ['MANAGER']),
});

const mapDispatchToProps = {
  saveUser,
  findUser,
  saveAddress,
  createAddress,
};

EditUser = userPage(connect(mapStateToProps, mapDispatchToProps)(EditUser));

export default EditUser;
